import { getAuthHeaders, tempMeeApi } from '~/services/api';
import {
  IAddCardRequest,
  IConnectPlaidRequest,
  IFinalizePlaidVerifyPayload,
  IMintConnectLinkTokenResponse,
  IMintVerifyLinkTokenPayload,
  IMintVerifyLinkTokenResponse,
  TPaymentMethodsResponse,
} from './types';

export const getPaymentMethods = async (officeId?: string): Promise<TPaymentMethodsResponse> => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.get<TPaymentMethodsResponse>(
    '/payment/account/payment-method/',
    {
      headers: {
        ...headers,
        ...(officeId ? { 'x-office': officeId } : {}),
      },
    },
  );

  return response.data;
};

export const mintConnectLinkToken = async (): Promise<IMintConnectLinkTokenResponse> => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.post<IMintConnectLinkTokenResponse>(
    '/payment/account/plaid/',
    {},
    { headers },
  );

  return response.data;
};

export const connectPlaid = async (body: IConnectPlaidRequest) => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.post('/payment/account/plaid/connect', body, { headers });

  return response.data;
};

export const mintVerifyLinkToken = async ({
  candidateId,
}: IMintVerifyLinkTokenPayload): Promise<IMintVerifyLinkTokenResponse> => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.post<IMintVerifyLinkTokenResponse>(
    '/payment/account/plaid/verify-token',
    { candidateId },
    { headers },
  );

  return response.data;
};

export const finalizePlaidVerify = async (body: IFinalizePlaidVerifyPayload): Promise<null> => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.post<null>('/payment/account/plaid/verify', body, { headers });

  return response.data;
};

export const addCard = async (body: IAddCardRequest) => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.post('/payment/account/payment-method/', body, { headers });

  return response.data;
};

export const deletePaymentMethod = async (paymentId: string): Promise<void> => {
  const headers = await getAuthHeaders();
  await tempMeeApi.delete(`/payment/account/payment-method/${paymentId}`, { headers });
};

export const selectPaymentMethod = async (paymentId: string): Promise<void> => {
  const headers = await getAuthHeaders();
  await tempMeeApi.patch(`/payment/account/payment-method/${paymentId}`, {}, { headers });
};

export const paymentsApi = {
  getPaymentMethods,
  mintConnectLinkToken,
  connectPlaid,
  mintVerifyLinkToken,
  finalizePlaidVerify,
  addCard,
  deletePaymentMethod,
  selectPaymentMethod,
};
